import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const SocialMediaContainer = styled.div`
  display: none;
  margin-right: 28px;
  animation: fadeIn 0.5s;

  @media screen and (min-width: ${layout.subMd}) {
    display: block;
  }

  svg {
    width: 32px;
    margin: 0 20px;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`
